import { render, staticRenderFns } from "./EnvIndicator.vue?vue&type=template&id=e6d50f70&scoped=true"
import script from "./EnvIndicator.vue?vue&type=script&lang=js"
export * from "./EnvIndicator.vue?vue&type=script&lang=js"
import style0 from "./EnvIndicator.vue?vue&type=style&index=0&id=e6d50f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d50f70",
  null
  
)

export default component.exports